import Reveal from "@/components/base/Reveal";

const topics = [
  "家庭伦理",
  "婚姻关系",
  "社会议题",
  "成长题材",
  "中文字幕",
  "高清版本",
  "主题合集",
  "经典推荐",
];

const quickLinks = [
  { id: "genres", label: "题材导览" },
  { id: "subtitle", label: "中字指南" },
  { id: "collection", label: "精选片单" },
  { id: "timeline", label: "经典年表" },
  { id: "mood", label: "按心情选" },
  { id: "faq", label: "常见问题" },
];

export default function SiteFooter() {
  return (
    <>
      <section id="about" className="py-16 md:py-20 bg-background-50">
        <div className="max-w-6xl mx-auto px-4 md:px-6">
          <Reveal>
            <div className="rounded-lg border border-background-200 bg-background-100 p-6 md:p-10 grid grid-cols-1 lg:grid-cols-12 gap-8">
              <div className="lg:col-span-7">
                <span className="text-xs md:text-sm font-label tracking-widest text-primary-600 uppercase">About This Page</span>
                <h2 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950">关于这个页面</h2>
                <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-600">
                  这是一份围绕欧美伦理电影的单页浏览指南，把题材分类、中字与高清的观看要点、精选片单、
                  经典年表与入门路径放在同一页里，方便你一次读完、按需跳转。
                </p>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                  片名、年份与地区为公开基础信息；内容解读属于主题层面的一般性说明，帮助你判断是否对味，
                  并不替代完整的剧情介绍或影评。页面不提供在线播放、账号或真实提交功能，所有筛选与展开都只在本地进行。
                </p>
              </div>
              <div className="lg:col-span-5">
                <p className="text-xs font-label tracking-widest text-foreground-500 uppercase">本页涉及的话题</p>
                <ul className="mt-4 flex flex-wrap gap-2">
                  {topics.map((t) => (
                    <li key={t} className="px-3 py-1.5 rounded-full bg-accent-100 text-accent-900 text-xs md:text-sm">
                      {t}
                    </li>
                  ))}
                </ul>
                <div className="mt-6 rounded-md bg-secondary-50 border border-secondary-200 p-4 flex gap-3">
                  <i className="ri-information-line text-secondary-600 text-xl shrink-0"></i>
                  <p className="text-xs md:text-sm leading-relaxed text-foreground-600">
                    请在合法合规的渠道观看影片，本页仅作内容整理与话题讨论之用。
                  </p>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      <footer className="bg-foreground-950 text-background-300">
        <div className="max-w-6xl mx-auto px-4 md:px-6 py-12 md:py-14">
          <div className="flex flex-col md:flex-row gap-10 md:gap-16">
            <div className="md:w-1/3">
              <div className="flex items-center gap-2">
                <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
                  <i className="ri-film-line text-lg"></i>
                </span>
                <span className="font-heading text-lg font-semibold text-background-50">欧美伦理电影</span>
              </div>
              <p className="mt-4 text-sm leading-relaxed text-background-400 max-w-xs">
                以中字、中文字幕、高清与合集为重点的欧美伦理电影浏览指南，覆盖经典与推荐等主题线索。
              </p>
            </div>

            <nav className="md:w-1/3">
              <h3 className="text-xs font-label tracking-widest text-background-500 uppercase">页面导航</h3>
              <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2">
                {quickLinks.map((l) => (
                  <li key={l.id}>
                    <a href={`#${l.id}`} className="text-sm text-background-300 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap">
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>

            <div className="md:w-1/3">
              <h3 className="text-xs font-label tracking-widest text-background-500 uppercase">浏览提示</h3>
              <ul className="mt-4 space-y-3 text-sm text-background-400">
                <li className="flex gap-2.5">
                  <i className="ri-arrow-right-s-line text-accent-400 shrink-0"></i>
                  <span>页码内的筛选与展开均在本地完成，不会提交任何数据。</span>
                </li>
                <li className="flex gap-2.5">
                  <i className="ri-arrow-right-s-line text-accent-400 shrink-0"></i>
                  <span>建议配合顶部导航逐段浏览，信息更连贯。</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
            <p className="text-xs text-background-500">© 2026 欧美伦理电影 · 内容整理与话题浏览页面</p>
            <a
              href="#top"
              className="inline-flex items-center gap-1.5 text-xs text-background-400 hover:text-accent-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-arrow-up-line"></i>
              回到顶部
            </a>
          </div>
        </div>
      </footer>
    </>
  );
}